import script from "./BacklogContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./BacklogContainer.vue?vue&type=script&setup=true&lang=js"

import "./BacklogContainer.vue?vue&type=style&index=0&id=2dac83ac&lang=sass&scoped=true"

import exportComponent from "/home/goran/projects/plodine/plodine/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dac83ac"]])

export default __exports__